import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import css from './CustomTopbarMobileMenu.module.css';
import NamedLink from '../../NamedLink/NamedLink';
import Icons from '../../Icons/Icons';
import classNames from 'classnames';
import Button from '../../Button/Button';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import LinkedLogo from '../../Logo/LinkedLogo';
import { apiBaseUrl } from '../../../util/api';

/* ==================== PREVIOUS CODE - COMMENTED OUT ====================
const menuSections = intl => [
  {
    title: intl.formatMessage({ id: 'CustomTopbarMobileMenu.homeDesigns' }),
    links: [
      { name: '/how-it-works', labelId: 'CustomTopbarMobileMenu.howItWorks' },
      { name: '/home-designs?pub_house_type=rural', labelId: 'CustomTopbarMobileMenu.rural' },
      { name: '/home-designs?pub_house_type=suburban', labelId: 'CustomTopbarMobileMenu.suburban' },
      { name: '/home-designs?pub_house_type=urban', labelId: 'CustomTopbarMobileMenu.urban' },
      {
        name: '/home-designs?pub_house_type=bungalows',
        labelId: 'CustomTopbarMobileMenu.bungalows',
      },
      { name: '/', isDisabled: true, labelId: 'CustomTopbarMobileMenu.buildingPlots' },
      { name: '/home-designs', labelId: 'CustomTopbarMobileMenu.viewAll' },
    ],
  },
  {
    titleLink: 'trusted-suppliers',
    title: intl.formatMessage({ id: 'CustomTopbarMobileMenu.trustedSuppliers' }),
    links: [
      { name: '/land-finding', labelId: 'CustomTopbarMobileMenu.landFinding' },
      { name: '/finance', labelId: 'CustomTopbarMobileMenu.finance' },
      { name: '/insurance', labelId: 'CustomTopbarMobileMenu.insurance' },
      { name: '/architects-planning-consultancy', labelId: 'CustomTopbarMobileMenu.architects' },
      { name: '/offsite-suppliers', labelId: 'CustomTopbarMobileMenu.offsiteSuppliers' },
      { name: '/structural-engineers', labelId: 'CustomTopbarMobileMenu.structuralEngineers' },
      { name: '/groundworks-contractors', labelId: 'CustomTopbarMobileMenu.groundworks' },
      // { name: '/community', labelId: 'CustomTopbarMobileMenu.more',  },
    ],
  },
  {
    title: intl.formatMessage({ id: 'CustomTopbarMobileMenu.community' }),
    links: [
      { name: '/community', labelId: 'CustomTopbarMobileMenu.caseStudies' },
      {
        name: '/static/media/newsletter1.ae396ef2d14071401d45.pdf',
        labelId: 'CustomTopbarMobileMenu.newsletters',
      },
      { name: '/', labelId: 'CustomTopbarMobileMenu.webinarsComing' },
      { name: '/blogs', labelId: 'CustomTopbarMobileMenu.blogs' },
      { name: '/offsite-construction', labelId: 'CustomTopbarMobileMenu.offsiteConstruction' },
    ],
  },
  {
    title: intl.formatMessage({ id: 'CustomTopbarMobileMenu.aboutUs' }),
    links: [
      { name: '/about', labelId: 'CustomTopbarMobileMenu.whoWeAre' },
      { name: '/blogs', labelId: 'CustomTopbarMobileMenu.blogs' },
      { name: '/faq', labelId: 'CustomTopbarMobileMenu.faq' },
      { name: '/investors', labelId: 'CustomTopbarMobileMenu.investors' },
    ],
  },
];

const MenuSection = ({ title, links, intl, titleLink = false }) => {
  const history = useHistory();
  const handleClick = (e, isDisabled) => {
    if (isDisabled) {
      e.preventDefault();
    }
  };

  return (
    <div className={css.columnsWrapper}>
      {titleLink ? (
        <h3 className={css.redirectLinks} role="button" onClick={() => history.push(`/${titleLink}`)}>
          {title}
        </h3>
      ) : (
        <h3>{title}</h3>
      )}
      <div className={css.column}>
        {links.map(({ name, labelId, isDisabled = false }, idx) => (
          <a
            key={idx}
            className={classNames(css.columnItem, { [css.disabled]: isDisabled })}
            href={name}
            onClick={e => handleClick(e, isDisabled)}
          >
            {intl.formatMessage({ id: labelId })}
            {isDisabled && (
              <span className={css.lockedLink}>
                <Icons name="lock" />
              </span>
            )}
          </a>
        ))}
      </div>
    </div>
  );
};

const OldCustomTopbarMobileMenu = ({ handleClose, currentUser, onLogout = () => {} }) => {
  const intl = useIntl();
  const userType = currentUser?.attributes?.profile?.publicData?.userType;
  const isAuthenticated = Boolean(currentUser?.id?.uuid);
  const canUpload = (userType === 'houseBuilder' || userType === 'architect') && isAuthenticated;
  return (
    <div className={css.wrapper}>
      <div className={css.exitButton} onClick={handleClose}>
        <Icons name="cross" />
      </div>

      {menuSections(intl).map((section, index) => (
        <MenuSection key={index} intl={intl} {...section} />
      ))}

      {isAuthenticated && (
        <div className={css.columnsWrapper}>
          <h3>{intl.formatMessage({ id: 'CustomTopbarMobileMenu.profileSection' })}</h3>
          <div className={css.column}>
            <NamedLink name="ManageListingsPage" className={css.columnItem}>
              {intl.formatMessage({ id: 'TopbarDesktop.yourListingsLink' })}
            </NamedLink>
            <NamedLink name="ProfileSettingsPage" className={css.columnItem}>
              {intl.formatMessage({ id: 'TopbarDesktop.profileSettingsLink' })}
            </NamedLink>
            <NamedLink name="AccountSettingsPage" className={css.columnItem}>
              {intl.formatMessage({ id: 'TopbarDesktop.accountSettingsLink' })}
            </NamedLink>
            <NamedLink name="DocumentManagementPage" className={css.columnItem}>
              {intl.formatMessage({ id: 'TopbarDesktop.documentManagementPage' })}
            </NamedLink>
            <NamedLink name="MoodMapPage" className={css.columnItem}>
              Mood board
            </NamedLink>
            <NamedLink name="CostEstimationDetailsPage" className={css.columnItem}>
              {intl.formatMessage({ id: 'TopbarDesktop.costEstimationToolDetails' })}
            </NamedLink>
            <Button className={css.logoutButton} onClick={onLogout}>
              {intl.formatMessage({ id: 'TopbarDesktop.logout' })}
            </Button>
          </div>
        </div>
      )}

      {canUpload ? (
        <NamedLink name="NewListingPage" className={css.pageLink}>
          {intl.formatMessage({ id: 'CustomTopbarMobileMenu.uploadDesigns' })}
        </NamedLink>
      ) : (
        !isAuthenticated && (
          <NamedLink name="SignupPage" className={css.pageLink}>
            {intl.formatMessage({ id: 'CustomTopbarMobileMenu.uploadDesigns' })}
          </NamedLink>
        )
      )}
    </div>
  );
};
==================== END OF PREVIOUS CODE ==================== */

// Import the menu config from desktop (reusing the same structure)
import CHAT from './images/speakTothem.png';

// Static menu config for non-dynamic menus
const STATIC_MENU_CONFIG = {
  'Marketplace': {
    subtitle: 'Visit Market Place',
    description: 'Find suitable designs, compare options, and start building',
    links: [
      { label: 'View Marketplace', href: '/home-designs', isRed: true },
      { label: 'Join Our Marketplace', href: '/signup', isRed: true, pageName: 'SignupPage' },
    ],
    showSpeakToTeam: true,
  },
  'Trusted Suppliers': {
    subtitle: 'Visit Trusted Suppliers',
    description: 'Verified. Experienced. Ready to quote.',
    links: [
      { label: 'Trusted Suppliers', href: '/trusted-suppliers', isRed: true },
      { label: 'Advertise Your Services', href: 'https://calendly.com/themodernbuilder/customer-experience', isRed: true, isExternal: true },
    ],
    showSpeakToTeam: true,
  },
  'Resources': {
    links: [
      { label: 'Blogs', href: '/blogs' },
      { label: 'About Us', href: '/about' },
      { label: 'Construction Budget Planner', href: '/cost-estimation' },
      { label: 'Cost Calculator', href: '/self-build-blogs/how-much-does-it-cost-to-self-build-a-house-in-2026' },
    ],
    cta: {
      text: 'Ready to get started?',
      linkText: 'Sign up for free',
      href: '/signup',
      pageName: 'SignupPage',
    },
  },
};

// New mobile menu section component with expand/collapse functionality
const ExpandableSection = ({ title, isExpanded, onToggle, children }) => {
  return (
    <div className={css.expandableSection}>
      <div className={css.sectionHeader} onClick={onToggle}>
        <h3 className={css.sectionTitle}>{title}</h3>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={css.chevronIcon}
          style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}
        >
          <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      {isExpanded && <div className={css.sectionContent}>{children}</div>}
    </div>
  );
};

const CustomTopbarMobileMenu = ({ handleClose, currentUser, onLogout = () => {} }) => {
  const intl = useIntl();
  const history = useHistory();
  const isAuthenticated = Boolean(currentUser?.id?.uuid);
  const [isGeneratingToken, setIsGeneratingToken] = useState(false);

  // Get environment variables for LeadFlow
  const leadflowSignupUrl = process.env.REACT_APP_LEADFLOW_SIGNUP_URL;
  const leadflowAppUrl = process.env.REACT_APP_LEADFLOW_APP_URL;

  // Check LeadFlow access
  const isLeadflowAccessProvided = currentUser?.attributes?.profile?.publicData?.isLeadflowAccessProvided;

  // Handle SSO token generation and redirect to LeadFlow
  const handleAccessLeadFlow = async () => {
    try {
      setIsGeneratingToken(true);

      console.log('[ViewLeads Mobile] User clicked View Leads - generating SSO token');

      // Build API URL
      const apiUrl = `${apiBaseUrl()}/api/leadflow/generate-sso-token`;
      console.log('API URL:', apiUrl);

      // Call backend to generate SSO token
      const response = await fetch(apiUrl, {
        method: 'POST',
        credentials: 'include', // Include cookies for authentication
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });

      console.log('Response status:', response.status);

      if (!response.ok) {
        const errorData = await response.json();
        console.error('API error:', errorData);
        throw new Error(errorData.message || 'Failed to generate SSO token');
      }

      const data = await response.json();
      console.log('API response:', data);

      if (data.success && data.data.redirectUrl) {
        console.log('SSO token generated, redirecting to:', data.data.redirectUrl);
        // Open LeadFlow in a new tab with SSO token
        window.open(data.data.redirectUrl, '_blank');
        setIsGeneratingToken(false);
      } else {
        console.error('Invalid response format:', data);
        alert('Failed to access LeadFlow. Please try again or contact support.');
        setIsGeneratingToken(false);
      }
    } catch (error) {
      console.error('LeadFlow SSO error:', error);
      alert(`Error accessing LeadFlow: ${error.message}`);
      setIsGeneratingToken(false);
    }
  };

  // Get second button config for LeadFlow menu based on authentication and access
  const getLeadFlowSecondButton = () => {
    if (!isAuthenticated) {
      // Not logged in - redirect to signup page
      return {
        label: 'Sign in',
        href: '/signup',
        pageName: 'SignupPage',
        isRed: true,
      };
    } else if (!isLeadflowAccessProvided) {
      // Logged in but no access - redirect to external signup URL
      return {
        label: 'Try Leadflow for free',
        href: leadflowSignupUrl,
        isRed: true,
        isExternal: true,
      };
    } else {
      // Logged in with access - use SSO to access LeadFlow
      return {
        label: isGeneratingToken ? 'Connecting...' : 'View Leads',
        onClick: handleAccessLeadFlow,
        isRed: true,
        disabled: isGeneratingToken,
      };
    }
  };

  // Build dynamic menu config
  const MOBILE_MENU_CONFIG = {
    'LeadFlow': {
      subtitle: 'Construction Leads. Fast',
      description: 'Early access to live UK planning data & Outreach',
      links: [
        { label: 'Book demo', href: 'https://calendly.com/themodernbuilder/discovery', isRed: true, isExternal: true },
        getLeadFlowSecondButton(),
      ],
      showSpeakToTeam: true,
    },
    ...STATIC_MENU_CONFIG,
  };

  // State for expandable sections - only one can be open at a time, all closed by default
  const [expandedSections, setExpandedSections] = useState({
    leadflow: false,
    marketplace: false,
    trustedSuppliers: false,
    resources: false,
    myAccount: false,
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => {
      // If clicking the currently open section, close it
      if (prev[section]) {
        return {
          leadflow: false,
          marketplace: false,
          trustedSuppliers: false,
          resources: false,
          myAccount: false,
        };
      }
      // Otherwise, close all sections and open the clicked one
      return {
        leadflow: false,
        marketplace: false,
        trustedSuppliers: false,
        resources: false,
        myAccount: false,
        [section]: true,
      };
    });
  };

  const handleLinkClick = (href, pageName, isExternal) => {
    if (isExternal) {
      window.open(href, '_blank');
    } else if (pageName) {
      // Use NamedLink navigation
      history.push(href);
    } else {
      // Regular navigation
      window.location.href = href;
    }
  };

  return (
    <div className={css.wrapper}>
      {/* Logo and Close Button Row */}
      <div className={css.headerRow}>
        <LinkedLogo layout={'mobile'} alt={intl.formatMessage({ id: 'Topbar.logoIcon' })} />
        <div className={css.exitButton} onClick={handleClose}>
          <Icons name="cross" />
        </div>
      </div>

      {/* Create Account Button - Always visible for non-authenticated users */}
      {!isAuthenticated ? (
        <NamedLink name="SignupPage" className={css.createAccountButton}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Create Account
        </NamedLink>
      ) : null}

      {currentUser && <><div className={css.profileMenuLabel}>
        <Icons name="signupIcon" />
        <span className={css.userName}>
          {currentUser?.attributes?.profile?.displayName ||
            currentUser?.attributes?.profile?.firstName ||
            'User Name'}
        </span>
      </div></>}

      {/* LeadFlow Section */}
      <ExpandableSection
        title="LeadFlow"
        isExpanded={expandedSections.leadflow}
        onToggle={() => toggleSection('leadflow')}
      >
        <div className={css.leadflowContent}>
          <h4 className={css.leadflowSubtitle}>{MOBILE_MENU_CONFIG.LeadFlow.subtitle}</h4>
          <p className={css.leadflowDescription}>{MOBILE_MENU_CONFIG.LeadFlow.description}</p>
          <div className={css.leadflowActions}>
            {MOBILE_MENU_CONFIG.LeadFlow.links.map((link, idx) => {
              // If link has onClick handler, render as button
              if (link.onClick) {
                return (
                  <button
                    key={idx}
                    onClick={link.onClick}
                    disabled={link.disabled}
                    className={css.bookDemoLink}
                    style={{
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      width: '100%',
                      textAlign: 'left',
                      cursor: link.disabled ? 'not-allowed' : 'pointer',
                      opacity: link.disabled ? 0.6 : 1,
                    }}
                  >
                    {link.label} <span className={css.arrow}>→</span>
                  </button>
                );
              }

              // Regular link rendering
              return link.pageName ? (
                <NamedLink key={idx} name={link.pageName} className={css.bookDemoLink}>
                  {link.label} <span className={css.arrow}>→</span>
                </NamedLink>
              ) : link.isExternal ? (
                <a key={idx} href={link.href} target="_blank" rel="noopener noreferrer" className={css.bookDemoLink}>
                  {link.label} <span className={css.arrow}>→</span>
                </a>
              ) : (
                <a key={idx} href={link.href} className={css.bookDemoLink}>
                  {link.label} <span className={css.arrow}>→</span>
                </a>
              );
            })}
          </div>
          {MOBILE_MENU_CONFIG.LeadFlow.showSpeakToTeam && (
            <a
              href="https://calendly.com/themodernbuilder/customer-support"
              target="_blank"
              rel="noopener noreferrer"
              className={css.speakToTeam}
            >
              {/* <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                <path d="M10 8L16 12L10 16V8Z" fill="currentColor"/>
              </svg> */}
              <img src={CHAT} alt="Chat" style={{ width: '20px', height: '20px' }} />
              <span>Speak to the team</span>
            </a>
          )}
        </div>
      </ExpandableSection>

      {/* Marketplace Section */}
      <ExpandableSection
        title="Marketplace"
        isExpanded={expandedSections.marketplace}
        onToggle={() => toggleSection('marketplace')}
      >
        <div className={css.marketplaceContent}>
          <h4 className={css.sectionSubtitle}>{MOBILE_MENU_CONFIG.Marketplace.subtitle}</h4>
          <p className={css.sectionDescription}>{MOBILE_MENU_CONFIG.Marketplace.description}</p>
          <div className={css.sectionActions}>
            {MOBILE_MENU_CONFIG.Marketplace.links.map((link, idx) => (
              link.pageName ? (
                <NamedLink key={idx} name={link.pageName} className={css.actionLink}>
                  {link.label} <span className={css.arrow}>→</span>
                </NamedLink>
              ) : (
                <a key={idx} href={link.href} className={css.actionLink}>
                  {link.label} <span className={css.arrow}>→</span>
                </a>
              )
            ))}
          </div>
          {MOBILE_MENU_CONFIG.Marketplace.showSpeakToTeam && (
            <a
              href="https://calendly.com/themodernbuilder/customer-support"
              target="_blank"
              rel="noopener noreferrer"
              className={css.speakToTeam}
            >
              {/* <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                <path d="M10 8L16 12L10 16V8Z" fill="currentColor"/>
              </svg> */}
              <img src={CHAT} alt="Chat" style={{ width: '20px', height: '20px' }} />
              <span>Speak to the team</span>
            </a>
          )}
        </div>
      </ExpandableSection>

      {/* Trusted Suppliers Section */}
      <ExpandableSection
        title="Trusted Suppliers"
        isExpanded={expandedSections.trustedSuppliers}
        onToggle={() => toggleSection('trustedSuppliers')}
      >
        <div className={css.suppliersContent}>
          <h4 className={css.sectionSubtitle}>{MOBILE_MENU_CONFIG['Trusted Suppliers'].subtitle}</h4>
          <p className={css.sectionDescription}>{MOBILE_MENU_CONFIG['Trusted Suppliers'].description}</p>
          <div className={css.sectionActions}>
            {MOBILE_MENU_CONFIG['Trusted Suppliers'].links.map((link, idx) => (
              link.isExternal ? (
                <a key={idx} href={link.href} target="_blank" rel="noopener noreferrer" className={css.actionLink}>
                  {link.label} <span className={css.arrow}>→</span>
                </a>
              ) : (
                <a key={idx} href={link.href} className={css.actionLink}>
                  {link.label} <span className={css.arrow}>→</span>
                </a>
              )
            ))}
          </div>
          {MOBILE_MENU_CONFIG['Trusted Suppliers'].showSpeakToTeam && (
            <a
              href="https://calendly.com/themodernbuilder/customer-support"
              target="_blank"
              rel="noopener noreferrer"
              className={css.speakToTeam}
            >
              {/* <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                <path d="M10 8L16 12L10 16V8Z" fill="currentColor"/>
              </svg> */}
              <img src={CHAT} alt="Chat" style={{ width: '20px', height: '20px' }} />
              <span>Speak to the team</span>
            </a>
          )}
        </div>
      </ExpandableSection>

      {/* Resources Section */}
      <ExpandableSection
        title="Resources"
        isExpanded={expandedSections.resources}
        onToggle={() => toggleSection('resources')}
      >
        <div className={css.resourcesContent}>
          <div className={css.simpleLinks}>
            {MOBILE_MENU_CONFIG.Resources.links.map((link, idx) => (
              <a key={idx} href={link.href} className={css.simpleLink}>
                {link.label}
              </a>
            ))}
          </div>
          {MOBILE_MENU_CONFIG.Resources.cta && (
            <div className={css.resourcesCta}>
              <p>{MOBILE_MENU_CONFIG.Resources.cta.text}</p>
              <NamedLink name={MOBILE_MENU_CONFIG.Resources.cta.pageName} className={css.ctaLink}>
                {MOBILE_MENU_CONFIG.Resources.cta.linkText}
              </NamedLink>
            </div>
          )}
        </div>
      </ExpandableSection>

      {/* Profile Section for Authenticated Users */}
      {isAuthenticated && (
        <ExpandableSection
          title="My Account"
          isExpanded={expandedSections.myAccount}
          onToggle={() => toggleSection('myAccount')}
        >
          <div className={css.profileContent}>
            {/* <NamedLink name="ManageListingsPage" className={css.simpleLink}>
              {intl.formatMessage({ id: 'TopbarDesktop.yourListingsLink' })}
            </NamedLink> */}
            <NamedLink name="ProfileSettingsPage" className={css.simpleLink}>
              {intl.formatMessage({ id: 'TopbarDesktop.profileSettingsLink' })}
            </NamedLink>
            {/* <NamedLink name="AccountSettingsPage" className={css.simpleLink}>
              {intl.formatMessage({ id: 'TopbarDesktop.accountSettingsLink' })}
            </NamedLink> */}
            <Button className={css.logoutButton} onClick={onLogout}>
              {intl.formatMessage({ id: 'TopbarDesktop.logout' })}
            </Button>
          </div>
        </ExpandableSection>
      )}
    </div>
  );
};

export default CustomTopbarMobileMenu;
